import { createSlice } from '@reduxjs/toolkit';

export const headerSlice = createSlice({
  name: 'header',
  initialState: {
    value: 0,
    isBreadcrumbShow: true,
    headerTitle: '',
    headerSubTitle: ''
  },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    setIsBreadcrumbShow: (state, action) => {
      state['isBreadcrumbShow'] = action.payload;
    },
    setHeaderTitle: (state, action) => {
      state['headerTitle'] = action.payload;
    },
    setHeaderSubTitle: (state, action) => {
      state['headerSubTitle'] = action.payload;
    }
  }
});

export const { increment, setIsBreadcrumbShow, setHeaderTitle, setHeaderSubTitle } = headerSlice.actions;

export default headerSlice.reducer;
